import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { ComponentVariantTransform, type Variants } from '../../utils/variant/variant';

@Component({
  selector: 'rt-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.less'],
  host: {
    '[class]': 'variant()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class TableComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'wide',
      'zebra-horizontal',
      'zebra-vertical',
      'zebra-odd-even',
      'plain-rows',
      'clickable-rows',
      'td-without-border',
      'heavy-thead',
      'outline',
      'raised',
      'dark-header-bordered',
    ],
  ];
  public readonly variant = input(...ComponentVariantTransform(TableComponent.VARIANTS));
}
